/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PlannerReviewRequest
 */
export interface PlannerReviewRequest {
    /**
     * The booking ID of the completed stay to review
     * @type {number}
     * @memberof PlannerReviewRequest
     */
    bookingId: number;
    /**
     * 
     * @type {string}
     * @memberof PlannerReviewRequest
     */
    hotelName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerReviewRequest
     */
    location?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerReviewRequest
     */
    checkIn?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PlannerReviewRequest
     */
    checkOut?: string | null;
}

/**
 * Check if a given object implements the PlannerReviewRequest interface.
 */
export function instanceOfPlannerReviewRequest(value: object): value is PlannerReviewRequest {
    if (!('bookingId' in value) || value['bookingId'] === undefined) return false;
    return true;
}

export function PlannerReviewRequestFromJSON(json: any): PlannerReviewRequest {
    return PlannerReviewRequestFromJSONTyped(json, false);
}

export function PlannerReviewRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PlannerReviewRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'bookingId': json['booking_id'],
        'hotelName': json['hotel_name'] == null ? undefined : json['hotel_name'],
        'location': json['location'] == null ? undefined : json['location'],
        'checkIn': json['check_in'] == null ? undefined : json['check_in'],
        'checkOut': json['check_out'] == null ? undefined : json['check_out'],
    };
}

export function PlannerReviewRequestToJSON(json: any): PlannerReviewRequest {
    return PlannerReviewRequestToJSONTyped(json, false);
}

export function PlannerReviewRequestToJSONTyped(value?: PlannerReviewRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'booking_id': value['bookingId'],
        'hotel_name': value['hotelName'],
        'location': value['location'],
        'check_in': value['checkIn'],
        'check_out': value['checkOut'],
    };
}

